// extracted by mini-css-extract-plugin
export default {"PortfolioItems":"Portfolio_PortfolioItems__8AI5K","container":"Portfolio_container__-3fog"};